import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import * as _ from 'lodash';
import { DatastoreService } from './datastore.service';
import { ApiService } from './jrni/api.service';
import { DepartmentService } from './jrni/department.service';


@Injectable({
  providedIn: 'root'
})
export class FormBuilderService {

  constructor(
    public dataStore: DatastoreService,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private departmentService: DepartmentService,

  ) { }

  questions: any = {};
  forms: any = {};
  schema: any = {};

  async buildForm(formId: string, formValues: any[]) {
    let parentDepartment = await this.departmentService.getParentDepartment();
    const pClient = parentDepartment.self.split("://")[1].split(".")[0]
    const schema = await this.apiService.getFormSchema(formId,parentDepartment.id,pClient) as any;
    const formGroup: FormGroup = new FormGroup({});
    this.schema[formId] = schema;
    if (schema.schema) {
      console.log(`buildForm ${formId}`, formValues)
      this.questions[formId] = schema.schema.fields;

      for (const field of schema.schema.fields) {
        const validators = (field.required) ? Validators.required : undefined;
        const foundField = formValues.find((f) => f.field === field.field);
        let f: any = false;
        // console.log(foundField);
        if (foundField) {
          if (field.type !== 'radio') {
            f = new FormControl(foundField.value, validators);
          }
          else {
            f = new FormControl(foundField.value.toString(), validators);
          }
          if (!field.editable) {
            f.reset({ value: f.value, disabled: true })
          }
        }
        else {
          if (field.type !== 'radio') {
            f = new FormControl('', validators);
          }
          else {
            f = new FormControl(null, validators);
          }
        }
        formGroup.addControl(field.field, f);
      }
    }
    this.forms[formId] = formGroup;
    return formGroup;
  }

  getFields(formId: string) {
    try {
      return this.questions[formId];
    }
    catch (err) {
      return [];
    }
  }

  getDetailsTitle(formId: string) {
    if (this.schema.hasOwnProperty(formId)) {
      if (this.schema[formId].schema.hasOwnProperty('form_name')) {
        return this.schema[formId].schema.form_name;
      }
    }
    return 'Test form';
  }

  getParentField(formId: string, field: any) {
    if (field.field) {
      if (field.type == 'checkbox') {
        if (field.checkbox_field) {
          const found = this.questions[formId].find((f: any) => f.field == field.checkbox_field);
          if (found) {
            return found;
          }
        }
      }
    }
    return {};
  }

  getTriggerField(formId: string, field: any, trigger: string) {
    if (field.field) {
      // if (field.type == 'checkbox') {
      //   if (field.checkbox_field) {
      //     const found = this.questions[formId].find((f: any) => f.field == trigger);
      //     if (found) {
      //       return found;
      //     }
      //   }
      // }
      // else {
        const found = this.questions[formId].find((f: any) => f.field == trigger);
        if (found) {
          return found;
        }
      }
    // }
    return {};
  }
  shouldShowConditional(formId: string, field: any, parentForm: any): boolean {
    // console.log(formId,field,parentForm)
    if (field.conditional) {
      let results = []; // see line 182
      let totalTrueRequired: any = {};
      const triggerFields = field.trigger.split("|");
      totalTrueRequired[field.field] = 0;

      let triggerTmpValue = field.trigger_value;
      if (typeof triggerTmpValue !== 'string') {
        triggerTmpValue = `${triggerTmpValue}`;
      }
      const triggerExpressions = triggerTmpValue.split("|");
      let retVal = false;
      let i = 0;
      for (const trigger of triggerFields) {
        const parent = this.getTriggerField(formId, field, trigger);
        let triggerValueStr = triggerExpressions[i];
        // const config = JSON.parse(this.dataStore.config);
       
        // if(config?.hiddenChildFormQuestions){
        //   if (config?.hiddenChildFormQuestions[parent.field]) {
        //     return true
        //   }
        // }
        // do we have a multi-part condition?
        const parts = triggerValueStr.split("&");
        for (const triggerValue of parts) {
          totalTrueRequired[field.field] += 1; // add the conditions to field
          if (["<", ">", "!"].indexOf(triggerValue[0]) !== -1) {
            // let val = false;
            const trigger: number = parseInt(triggerValue.substr(1));
            let parentFieldValue = parentForm.get(parent.field).value;
            // console.log(field.field + " trigger field:" + trigger, "Expression: " + triggerValue, "parent", parent.field, "parent val: ", parentFieldValue);

            let doSwitch = true;

            // In this switch statement I changed the value to be an array for multipart questions.
            // The array is summed up to check if there is any truthy values, if there are then true is returned
            // did this because if a trigger value of "<18&>15|no" where only the first trigger part is true the second runs
            // last and therefor is the returned value of false. 

            switch (triggerValue[0]) {
              case "<":
                if (parentFieldValue < trigger) {
                  // val = true;
                  results.push(true);
                }
                break;
              case ">":
                if (parentFieldValue > trigger) {
                  // val = true;
                  results.push(true);
                }
                break;
              case "!":
                if (parentFieldValue !== trigger) {
                  // val = true;
                  results.push(true);
                }
                break;
              default:
                // val = false;
                results.push(false);
            }
            // if (!val) {
            //   break; // This loop is an AND
            // }
          } else{

            let parentFieldValue = parentForm.get(parent.field).value;
            if(parentFieldValue === triggerValueStr){
              results.push(true);
            }
          }
          // console.log('val', results);
          // retVal = val;
          // retVal = results.some((e: any) => e === true);
        }
        i++;
      }
      // console.log(field.field, "retVal", retVal);

      // store errors to replace if a form is enabled
      let tempErrorStore = parentForm.controls[field.field]?.errors;
      if (triggerTmpValue.includes("&")) {
        // its multi conditional which means we can reduce the truth flag by 1 as its an OR
        totalTrueRequired[field.field] = (totalTrueRequired[field.field] - 1);
      }

      // Count the true conditions we have
      let trueCount = results.filter(value => value === true).length;
      // if (field.field == "child_postcode") {
      //   console.log(`question ${field.field} : true count: ${trueCount}`);
      //   console.log(`true count required: ${totalTrueRequired[field.field]}`);
      //   console.log(`-----------------------------------------------`);
      // }

      // If the true count matches the amount of conditions we have, it means
      // the trigger statement is true
      if (trueCount >= 1) {
        retVal = true;
      } else {
        retVal = false;
      }

      if (retVal) { // disable fields that are not visible
        if (parentForm.controls[field.field].status === "DISABLED") {
          parentForm.controls[field.field].enable();
        }
      } else {
        if (parentForm.controls[field.field].status !== "DISABLED") {
          parentForm.controls[field.field].setValue("")
          parentForm.controls[field.field].markAsPristine()
          parentForm.controls[field.field].markAsUntouched()
          parentForm.controls[field.field].disable();
        }
      }
      parentForm.controls[field.field].errors = tempErrorStore;
      // console.log(formId,field,retVal)

      return retVal;
    } else {
      return true;
    }

  }

  localAddress(address) { // non local addresses are charged extra
    // console.log(address)
    var custodian_codes = [2270, 2265, 2260, 2255, 2250, 2245, 2235, 2230, 2220, 2215, 2210, 2205]; //custodian_codes in kent
    const matchingCodes = custodian_codes.filter(code => {
      if(!address.LOCAL_CUSTODIAN_CODE){
        if (address.DPA) {
          if (code === address.DPA.LOCAL_CUSTODIAN_CODE) {
            return true;
          }
        }
        if (address.LPI) {
          if (code === address.LPI.LOCAL_CUSTODIAN_CODE) {
            return true;
          }
        }
      }
      if (address.LOCAL_CUSTODIAN_CODE === code) {
        return true;
      }
    })
    if (matchingCodes.length > 0) return true;
    else return false;
  }

}
